// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store, persister } from "./store"; // Adjust the path as needed
import { PersistGate } from "redux-persist/integration/react";
import { createRoot } from "react-dom/client";
import ThemeProvider from "./context/ThemeProvider"; // Import the ThemeProvider

// Get the root container and ensure it is not null
const container = document.getElementById("root");

if (container) {
  const root = createRoot(container); // `createRoot` expects a non-null HTMLElement
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persister}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
} else {
  console.error("Root container not found.");
}
